import React from "react";

const Invoice = ({ order }) => {
    const billing = order?.billing || {};
    const lineItems = order?.line_items || [];
    const meta = order?.meta_data || [];

    const getMeta = (key) =>
        meta.find((m) => m.key === key)?.value;

    const dateCreated = order?.date_created
        ? new Date(order.date_created).toLocaleDateString()
        : "-";

    /* ================= CALCULATIONS ================= */

    const subtotal = lineItems.reduce(
        (sum, item) => sum + Number(item.subtotal || 0),
        0
    );

    // GST from meta (Checkout source of truth)
    const gstAmount = Number(getMeta("gst_amount")) || 0;
    const cgst = Number(getMeta("cgst")) || 0;
    const sgst = Number(getMeta("sgst")) || 0;

    // WooCommerce totals (trust Woo)
    const discount = Number(order?.discount_total || 0);
    const shipping = Number(order?.shipping_total || 0);
    const grandTotal = Number(order?.total || 0);

    return (
        <div className="invoice-container">
            {/* ================= HEADER ================= */}
            <div className="invoice-header">
                <div className="invoice-logo">
                    <img src={require("../images/logo.png")} alt="MVL Pharmacy" />
                </div>
                <h1>MVL PHARMACY</h1>
                <p>GSTIN: {getMeta("gstin") || "-"}</p>
                <p>D.L. No: {getMeta("dl_number") || "-"}</p>
            </div>

            <div className="invoice-title">
                <h2>TAX INVOICE</h2>
            </div>

            {/* ================= DETAILS ================= */}
            <div className="invoice-details">
                <div className="bill-ship">
                    <div className="bill-to">
                        <h3>Bill To</h3>
                        <p>{billing.first_name} {billing.last_name}</p>
                        <p>{billing.address_1}</p>
                        <p>{billing.city}, {billing.state}</p>
                        <p>{billing.postcode}</p>
                        <p>{billing.phone}</p>
                    </div>

                    <div className="ship-to">
                        <h3>Doctor Details</h3>
                        <p><strong>Name:</strong> {getMeta("doctor_name") || "-"}</p>
                        <p>
                            <strong>Payment Type:</strong>{" "}
                            {order?.payment_method === "cod"
                                ? "Cash on Delivery"
                                : "Online"}
                        </p>
                    </div>
                </div>

                <div className="invoice-meta">
                    <p><strong>Invoice No:</strong> {order?.id}</p>
                    <p><strong>Bill Date:</strong> {dateCreated}</p>
                </div>
            </div>

            {/* ================= TABLE ================= */}
            <table className="invoice-table">
                <thead>
                    <tr>
                        <th>Sr</th>
                        <th>Product Name</th>
                        <th>HSN</th>
                        <th>Pack</th>
                        <th>Batch</th>
                        <th>Expiry</th>
                        <th>Qty</th>
                        <th>MRP</th>
                        <th>Rate</th>
                        <th>Amount</th>
                    </tr>
                </thead>

                <tbody>
                    {lineItems.map((item, index) => (
                        <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{item.name}</td>
                            <td>{item.meta_data?.find(m => m.key === "hsn")?.value || "-"}</td>
                            <td>{item.meta_data?.find(m => m.key === "pack")?.value || "-"}</td>
                            <td>{item.meta_data?.find(m => m.key === "batch")?.value || "-"}</td>
                            <td>{item.meta_data?.find(m => m.key === "expiry")?.value || "-"}</td>
                            <td>{item.quantity}</td>
                            <td>{item.meta_data?.find(m => m.key === "mrp")?.value || "-"}</td>
                            <td>{Number(item.price || 0).toFixed(2)}</td>
                            <td>{Number(item.subtotal || 0).toFixed(2)}</td>
                        </tr>
                    ))}

                    {/* ================= TOTALS ================= */}
                    <tr className="subtotal">
                        <td colSpan="9">Sub Total</td>
                        <td>{subtotal.toFixed(2)}</td>
                    </tr>

                    <tr className="subtotal">
                        <td colSpan="9">GST</td>
                        <td>{gstAmount.toFixed(2)}</td>
                    </tr>

                    {(cgst > 0 || sgst > 0) && (
                        <tr className="subtotal">
                            <td colSpan="9" style={{ fontSize: "12px", color: "#555" }}>
                                (CGST ₹{cgst.toFixed(2)} + SGST ₹{sgst.toFixed(2)})
                            </td>
                            <td></td>
                        </tr>
                    )}

                    <tr className="subtotal">
                        <td colSpan="9">Discount</td>
                        <td>-{discount.toFixed(2)}</td>
                    </tr>

                    <tr className="subtotal">
                        <td colSpan="9">Shipping Charge</td>
                        <td>{shipping.toFixed(2)}</td>
                    </tr>

                    <tr className="total">
                        <td colSpan="9"><strong>Grand Total</strong></td>
                        <td><strong>{grandTotal.toFixed(2)}</strong></td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

export default Invoice;
